/* Marketing / Funnel formatting — the shared GrowthOS formatters (growthos-shared/gxFormat,
   identical to the original lib/dashboardFormat.tsx) plus the page's ABM helpers. */
import { monthLabel as gxMonthLabel } from '../growthos-shared/gxFormat'

export { shortDate, integer, currency, percentage, compactCurrency, comparison } from '../growthos-shared/gxFormat'

// This page shows '—' (not '') for a missing month.
export const monthLabel = (ym) => (ym ? gxMonthLabel(ym) : '—')

export const isAbmSource = (name) => String(name ?? '').trim().toLowerCase() === 'abm'

export const ABM_LEAD_BASIS = 'ABM is counted on reply date (HubSpot "ABM Last Replied Date"), not contact create date — '
  + 'a contact counts in the period they replied to outreach (contacts that never replied count on their create date). '
  + 'Every other source here is counted on create date.'
